// 权限列表
export const PERMISSIONLIST = 'permission_list'

export const AUTH_TOKEN = 'Auth-Token';

export const SOCKET_TOKEN = 'socket_token';

export const USER_INFO = 'user_info'

export const VIDEO_SPEED = 'video_speed'

export const HAS_LOGIN = 'HAS_LOGIN'; // 是否登录

export const DEFAULT_OPENED_MENUS = 'defaultOpenedMenus'; // 展开的菜单

export const DEFAULT_ACTIVE_MENU = 'defaultActiveMenu'; // 被选中的菜单

export const UNREAD_NOTICE = 'unread_notice'; // 未读消息

export const MCT_LEVEL = 'mct_level'; /* 组织层级 */

export const LOCALE = 'locale'; /* 语言 */